import React from 'react';
import cn from 'classnames';
import { hasDateLimit } from '../utils';
import { MONTHS_ABBRS } from './constants';
import "./styles.css";
export var Months = function (_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate, viewDate = _a.viewDate, onSelectMonth = _a.onSelectMonth, showStartPanel = _a.showStartPanel;
    var viewYear = viewDate === null || viewDate === void 0 ? void 0 : viewDate.getFullYear();
    var viewMonthIndex = viewDate === null || viewDate === void 0 ? void 0 : viewDate.getMonth();
    var minMonth = minDate && new Date(minDate.getFullYear(), minDate.getMonth());
    var maxMonth = maxDate && new Date(maxDate.getFullYear(), maxDate.getMonth());
    var isDisabledMonth = function (monthIndex) {
        var checkedMonth = new Date(viewYear, monthIndex);
        return hasDateLimit(checkedMonth, minMonth, maxMonth);
    };
    var onClick = function (monthIndex) {
        onSelectMonth(monthIndex);
        showStartPanel();
    };
    return (React.createElement("div", { className: 'lk-ui_calendar-months' }, MONTHS_ABBRS.map(function (month, monthIndex) { return (React.createElement("span", { className: cn('lk-ui_calendar-month', {
            selected: monthIndex === viewMonthIndex,
            disabled: isDisabledMonth(monthIndex),
        }), onClick: function () { return onClick(monthIndex); }, key: "month-" + monthIndex }, month)); })));
};
